<template>
    <main>
        <integration-connector
            :active="false"
            :chosen="prelaunched"
            :connectLabel="$t('settings.integrations.zapier.link_button')"
            :extra-button-arrow-direction="extraInfo.visible ? 'up' : 'down'"
            href="https://zapier.com/apps/jobtoolz/integrations"
            icon="zapier-small"
            logo-classes="bg-zapier hover:bg-zapier-light text-white"
            :showExtraButton="extraInfo.show"
            translation-key="zapier"
            @connect="requestIntegration()"
            @extraButton="extraInfo.visible = !extraInfo.visible"
        />

        <div v-show="extraInfo.visible" id="zapierscript" class="pl-36">
            <p class="text-right font-semibold my-8">{{ $t('settings.integrations.zapier.info') }}</p>
        </div>
    </main>
</template>

<script>
import IntegrationConnector from './IntegrationConnector.vue';
import SvgIcon from '../ui/SvgIcon.vue';
import Postscribe from 'postscribe';

export default {
    components: {
        'integration-connector': IntegrationConnector,
        'svg-icon': SvgIcon,
    },
    data: function () {
        return {
            configuring: false,
            extraInfo: {
                show: true,
                visible: true,
            },
        };
    },
    props: {
        prelaunched: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        zapierEnabled() {
            // return this.currentCompany.zapier_enabled;
            return false;
        },
    },
    methods: {
        requestIntegration() {
            window.open('https://zapier.com/apps/jobtoolz/integrations');
        },
    },
    mounted() {
        //Load script to show 3 zapier integrations with postscribe (after async)
        let el = document.getElementById('zapierscript');

        if (el) {
            Postscribe(el, '<script src="https://zapier.com/apps/embed/widget.js?services=jobtoolz&limit=3"><\/script>');
        } else {
            this.extraInfo.show = false;
            this.extraInfo.visible = false;
        }
    },
};
</script>